import  { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft,Eye } from "lucide-react";
const PublicProfileView = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/marketplace/researcher/public/profile/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              'x-api-key': process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        setProfile(response.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchProfile();
  }, [id, BASE_URL]);

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (!profile) return <div className="text-center mt-10 text-red-500">No profile found</div>;

  return (
<div className="min-h-screen bg-gray-50 flex justify-center p-6">

  <div className="w-full p-6">

    {/* Back Button */}
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-2 text-gray-700 hover:text-black mb-6"
    >
      <ArrowLeft size={18} />
      Back
    </button>

 {/* Header */}
<div className="flex items-center gap-4 pb-4">
  <img
    src={profile?.researcher?.researcher?.profile_picture}
    alt="profile"
    className="w-20 h-20 rounded-xl object-cover"
  />

  <div>
    <h1 className="text-xl font-bold">
      {profile?.researcher?.researcher?.name}
    </h1>
    <p className="text-gray-500 text-sm">
      {profile?.researcher?.researcher?.institution}
    </p>
  </div>
</div>

{/* Info */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 text-sm">

  <div>
    <p className="text-gray-500">Email</p>
    <p className="font-medium">
      {profile?.researcher?.researcher?.email}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Degree</p>
    <p className="font-medium">
      {profile?.researcher?.researcher?.degree}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Affiliation</p>
    <p className="font-medium">
      {profile?.researcher?.researcher?.primary_affiliation}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Current Role</p>
    <p className="font-medium">
      {profile?.researcher?.researcher?.current_activity}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Research Areas</p>
    <p className="font-medium">
      {profile?.researcher?.researcher?.research_areas}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Online Status</p>
    <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-700">
      {profile?.researcher?.researcher?.last_seen_display}
    </span>
  </div>

  <div>
    <p className="text-gray-500">Research Type</p>
    <p className="font-medium">
      {profile?.researcher?.answers?.research_type}
    </p>
  </div>

  <div>
    <p className="text-gray-500">Active Project</p>
    <span className="px-3 py-1 rounded-full text-xs bg-blue-100 text-blue-700">
      {profile?.researcher?.answers?.has_active_project ? "Yes" : "No"}
    </span>
  </div>

</div>

{/* Bio */}
<div className="mt-6 pt-4">
  <p className="text-gray-500 text-sm mb-2">Bio</p>
  <p className="text-sm text-gray-700">
    {profile?.researcher?.researcher?.bio}
  </p>
</div>

{/* Research Interests */}
<div className="mt-4">
  <p className="text-gray-500 text-sm mb-2">Research Interests</p>
  <p className="text-sm text-gray-700">
    {profile?.researcher?.answers?.research_interests}
  </p>
</div>

    {/* FEED + OPPORTUNITIES */}
    <div className="mt-8 flex flex-col md:flex-row gap-6 text-sm">

      {/* Feed */}
      <div className="flex-1">
        <p className="text-gray-500 mb-3">Researcher Feed</p>

        <div className="flex flex-col gap-3">
          {profile?.university_posts?.map((post) => (
              <div
                        key={`${post.id}-${post.research_type}`} // Better unique key
                        onClick={()=>navigate(`/marketplace/feed/post/${post.id}?research_type=${post.research_type}&type=${post.publication_type}`)}
                        // onClick={() => {
                        //   window.history.pushState(
                        //     {},
                        //     "",
                        //     `/marketplace/independent_researcher/post/${post.id}?research_type=${post.research_type}&type=${post.publication_type}`
                        //   );
            
                        //   setType(post?.publication_type);
                        //   setSearchType(post?.research_type);
                        //   setPostId(post?.id);
                        //   setOpen(true);
                        // }}
                        className="mb-4 border border-gray-200 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-200"
                      >
                        <div className="p-6 w-full cursor-pointer">
                          {/* USER INFO */}
                          <div className="flex items-center gap-3 justify-between mb-4">
                            <div className="flex items-center gap-3"  onClick={(e)=>{
                                  e.stopPropagation()
                                   navigate(post?.university_data ? `/marketplace/university/${post?.university_data?.id}` : `/marketplace/independent_researcher/${post?.researcher}`)
                                }}>
                              <img
                                src={post?.university_data ? post?.university_data.university_logo : post?.profile_data?.profile_picture}
                                alt="University"
                                className="w-12 h-12 rounded-xl object-cover border-2 border-white shadow-sm"
                               
                              />
            
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-900">
                                  {post.university_data ? post?.university_data?.university_name :post?.profile_data?.name}
                                </span>
                                                      <span className="text-xs text-gray-600 mt-0.5">
                                    By <strong>{post.university_data ? post?.profile_data?.name : "Researcher"}</strong>
                                  </span>
                              </div>
                            </div>
                          </div>
            
                          {/* TAGS */}
                          <div className="flex flex-wrap gap-2 mb-2">
                            <span className="text-xs px-3 py-1 bg-gray-100 rounded-lg">
                              {post?.field_of_interest}
                            </span>
                            <span className="text-xs px-3 py-1 bg-blue-100 rounded-lg">
                              {post?.area_of_interest}
                            </span>
                          </div>
            
                          {/* TITLE */}
                          <div className="text-lg font-bold text-gray-900 mb-2">
                            {post.name}
                          </div>
            
                          {/* MEDIA */}
                          {post.publication_type === "image" && (
                            <img 
                              src={post.file} 
                              className="w-full h-48 object-cover rounded-lg" 
                              alt={post.name}
                            />
                          )}
            
                          {post.publication_type === "video" && (
                            <video 
                              src={post.file} 
                              controls 
                              className="w-full h-48 rounded-lg" 
                            />
                          )}
            
                          {post.publication_type === "audio" && (
                            <audio 
                              src={post.file} 
                              controls 
                              className="w-full mt-2" 
                            />
                          )}
            
                          {post.publication_type === "pdf" && (
                            <iframe
                              src={`${post.file}#toolbar=0`}
                              className="w-full h-48 rounded-lg"
                              title={post.name}
                            />
                          )}
            
                          {/* ACTIONS */}
                          {/* <ResearcherLikeCommentActions
                            postId={post?.id}
                            type={post?.research_type}
                            is_Liked={post?.is_liked}
                            likeCount={post?.like_count}
                            views={post?.views}
                          /> */}
                        </div>
                      </div>
          ))}
        </div>
      </div>

      {/* Opportunities */}
      <div className="flex-1">
        <p className="text-gray-500 mb-3">Researcher Opportunities</p>

        <div className="flex flex-col gap-3">
          {profile?.university_opportunities?.map((p, i) => (
             <div
      key={i}
      className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
    //   onClick={() =>{
    //   window.history.pushState({}, "", `/marketplace/independent_researcher/post/${p.id}?research_type=${p.research_type}&type=${p.publication_type}`);
    //   setType(p?.publication_type)
    //   setSearchType(p?.research_type) 
    //   setPostId(p?.id)
    //   setOpen(true)
    // }}
     onClick={()=>navigate(`/marketplace/feed/post/${p.id}?research_type=${p.research_type}&type=${p.publication_type}`)}
    >
      <div className="opp-header mb-4">
                  {/* First Row: Badge and Profile */}
                  <div className="flex items-center justify-between mb-3">
                    {/* Left: Badge */}
                    <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
                      {p.university_data ? p?.university_data?.university_name :p?.profile_data?.name}
                    </div>
                    <div className="flex items-center gap-1 text-gray-600 text-sm">
                      <Eye className="w-4 h-4" />
                      <span>{p?.views}</span>
                    </div>
                    {/* Right: Profile Section */}
                    <div
                      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
                    >
                     
                        <img
                           src={p?.university_data ? p?.university_data.university_logo : p?.profile_data?.profile_picture}
                    alt="University"
                          className="w-8 h-8 rounded-full object-cover border border-gray-300"
                          onClick={(e)=>{
                      e.stopPropagation()
                       navigate(p?.university_data ? `/marketplace/university/${p?.university_data?.id}` : `/marketplace/independent_researcher/${p?.researcher}`)
                    }}
                        />
                    </div>
                  </div>
                   <div className="text-lg text-gray-900 mb-2 mt-2 font-bold" >
                  {p?.name}  
                </div>
 <div className="p-1  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {p?.collaboration}
    </span>
    
    {/* <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.topic_of_interest}
    </span> */}
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {p?.visibility}
    </span>
  </div>
</div>
  <div className="w-full mt-4">
                      {/* Media Preview */}
              {p.publication_type === "image" && (
                <img
                  src={p.file}
                  alt={p.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {p.publication_type === "pdf" && (
                <iframe
                  src={`${p.file}#toolbar=0`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {(p.publication_type === "doc" || p.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    p.file
                  )}&embedded=true`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {p.publication_type === "video" && (
                <video
                  src={p.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {p.publication_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={p.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
                 
                </div>
    </div>
          ))}
        </div>
      </div>

    </div>

  </div>
</div>
  );
};

export default PublicProfileView;